import { Grid } from "@mui/material";
import { StyledLinkSpan, StyledTextSpan } from "../styled-components/StyledConsentSpan";

export default function AppFormLegalTerm() {
  return (
    <Grid item xs={12}>
      <StyledTextSpan>
        By clicking <span style={{ color: "#FC4C4C" }}>Next</span>, you agree to Caleb & Brown’s{" "}
        <StyledLinkSpan href="https://www.calebandbrown.com/terms-of-business" target="_blank">
          Terms of Business
        </StyledLinkSpan>{" "}
        and Website{" "}
        <StyledLinkSpan href="https://www.calebandbrown.com/website-terms-of-use" target="_blank">
          Terms of Use
        </StyledLinkSpan>
        , and consent to the collection, use, and disclosure of your personal information, as
        outlined in our{" "}
        <StyledLinkSpan href="https://www.calebandbrown.com/privacy-policy" target="_blank">
          Privacy Policy
        </StyledLinkSpan>
        , which includes data like your biometrics.
      </StyledTextSpan>
      <br />
      <br />
    </Grid>
  );
}
